/**
 * Usage:
 *
 * <MainLayout>
 *  {content}
 * </MainLayout>
 */

import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import AdaptiveNavBar from '../NavBar/AdaptiveNavBar';
import clsx from 'clsx';
import { MainLayoutStyle } from '../../../styles/MainLayoutStyle';

function MainLayout({ id, token, noHiddenOverflowX, verticalOverlay, SubPageHeader, children, stylesOverride }) {
    const classes = MainLayoutStyle(stylesOverride)();

    if (!token) {
        return <Redirect to="/patient/login" />;
    }

    return (
        <div
            className={clsx(classes.mainLayoutDiv, {
                [classes.noVisitDiv]: SubPageHeader === null,
                [classes.hiddenOverflowX]: !noHiddenOverflowX,
            })}
        >
            <AdaptiveNavBar mobilePresent />
            {SubPageHeader ? <SubPageHeader /> : ''}
            <div
                className={clsx({
                    [classes.verticalOverlay]: !!verticalOverlay,
                })}
            >
                <div id={id} className={classes.container}>
                    {children}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({ login }) => {
    return {
        token: login.session && login.session.token ? login.session.token : '',
    };
};

export default connect(mapStateToProps)(MainLayout);
